import { useEffect } from 'react';
// @mui
import Box from '@mui/material/Box';
// hooks
import { useGetSetting } from 'src/api/setting';
import { useBoolean } from 'src/hooks/use-boolean';
import { useResponsive } from 'src/hooks/use-responsive';
// components
import { useSettingsContext } from 'src/components/settings';
// utils
import { LOCAL_STORAGE_KEYS } from 'src/utils/constant';
import { localStorageSetItem } from 'src/utils/storage-available';
//
import { useGetSchoolInfor } from 'src/api/school';
import Header from './header';
import Main from './main';
import NavHorizontal from './nav-horizontal';
import NavMini from './nav-mini';
import NavVertical from './nav-vertical';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function HomeLayout({ children }: Props) {
  const settings = useSettingsContext();

  const lgUp = useResponsive('up', 'lg');

  const nav = useBoolean();

  const isHorizontal = settings.themeLayout === 'horizontal';

  const isMini = settings.themeLayout === 'mini';

  const renderNavMini = <NavMini />;

  const renderHorizontal = <NavHorizontal />;

  const renderNavVertical = <NavVertical openNav={nav.value} onCloseNav={nav.onFalse} />;
  const { data: settingData } = useGetSetting({
    revalidateOnFocus: false,
  });
  const { data: schoolData } = useGetSchoolInfor({
    revalidateOnFocus: false,
  });

  useEffect(() => {
    if (settingData) {
      localStorageSetItem(LOCAL_STORAGE_KEYS.LIBRARY_SETTINGS, settingData.data);
    }
  }, [settingData]);

  useEffect(() => {
    if (schoolData) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { emailSMTP, passwordSMTP, ...schoolInfor } = schoolData.data;
      localStorageSetItem(LOCAL_STORAGE_KEYS.LIBRARY_SETTINGS, schoolInfor);
    }
  }, [schoolData]);

  if (isHorizontal) {
    return (
      <>
        <Header onOpenNav={nav.onTrue} />

        {lgUp ? renderHorizontal : renderNavVertical}

        <Main>{children}</Main>
      </>
    );
  }

  if (isMini) {
    return (
      <>
        <Header onOpenNav={nav.onTrue} />

        <Box
          sx={{
            minHeight: 1,
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
          }}
        >
          {lgUp ? renderNavMini : renderNavVertical}

          <Main>{children}</Main>
        </Box>
      </>
    );
  }

  return (
    <>
      <Header onOpenNav={nav.onTrue} />

      <Box
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
        }}
      >
        {renderNavVertical}

        <Main>{children}</Main>
      </Box>
    </>
  );
}
